import { animated, AnimatedProps } from '@react-spring/web';
import { ComponentPropsWithoutRef } from 'react';

// Create properly typed animated components
export const AnimatedDiv = animated.div as React.ComponentType<
  AnimatedProps<ComponentPropsWithoutRef<'div'>>
>;
